import styles from '../../../../../../ApplicationMaintenance.module.scss';
import ExtensionTypeSelect from '../../../../../../components/ExtensionTypeSelect';
import classNames from 'classnames';
const AppExtensionForm = ({ appExtension, handleChange, app }) => {
	const resolveTextAreaNull = value => {
		if (value !== null) {
			return value;
		} else {
			return '';
		}
	};
	return (
		<div>
			{/* description : string (64) */}
			<div className={styles.detailLabel}>
				<p>
					Description{' '}
					<span className={styles.characterCount}>
						(
						{appExtension?.description?.length
							? appExtension.description.length
							: 0}
						/{64})
					</span>
				</p>

				<textarea
					className={classNames([styles.detailInfo, styles.textArea])}
					type='text'
					value={resolveTextAreaNull(appExtension.description)}
					onChange={e => handleChange(e)}
					name='description'
					maxLength={64}
					rows={5}
					id='appExtension_description'
				/>
			</div>
			{/* approveAppCre_Email : string (128) */}
			<div className={styles.detailLabel}>
				<p>
					Approvers
					<span className={styles.characterCount}>
						(
						{appExtension?.approveAppCre_Email?.length
							? appExtension.approveAppCre_Email.length
							: 0}
						/{128})
					</span>
				</p>
				<p className={styles.sub_label}>
					For Multiple Approvers, format as a semicolon (;) delimited
					list (i.e RecipientOne@UPMC.edu;RecipientTwo@UPMC.edu)
				</p>
				<input
					name='approveAppCre_Email'
					id='appExtension_approveAppCre_Email'
					type='text'
					maxLength={128}
					value={resolveTextAreaNull(
						appExtension.approveAppCre_Email
					)}
					className={styles.width_full}
					onChange={e => handleChange(e)}
				/>
			</div>
			{/* notifyAppCre_Email : string (128) */}
			<div className={styles.detailLabel}>
				<p>
					Notify Email
					<span className={styles.characterCount}>
						(
						{appExtension?.notifyAppCre_Email?.length
							? appExtension.notifyAppCre_Email.length
							: 0}
						/{128})
					</span>
				</p>
				<p className={styles.sub_label}>
					Format Multiple Recipients, format as a semicolon (;)
					delimited list (i.e
					RecipientOne@UPMC.edu;RecipientTwo@UPMC.edu)
				</p>
				<input
					name='notifyAppCre_Email'
					id='appExtension_notifyAppCre_Email'
					type='text'
					maxLength={128}
					value={resolveTextAreaNull(appExtension.notifyAppCre_Email)}
					className={styles.width_full}
					onChange={e => handleChange(e)}
				/>
			</div>
			{/*extensionID*/}
			<ExtensionTypeSelect
				extensionTypes={app.extensions}
				extensionID={appExtension.extension?.fiid ?? 0}
				handleChange={e =>
					handleChange({
						target: {
							name: 'extension',
							value: {
								fiid: e.target.value,
							},
						},
					})
				}
			/>
			{/*order*/}
			<div className={styles.detailLabel}>
				<p>Order </p>

				<input
					type='number'
					value={appExtension?.order}
					onChange={e => handleChange(e)}
					name='order'
					min={1}
					id='appExtension_order'
				/>
			</div>
		</div>
	);
};

export default AppExtensionForm;
